import gql from 'graphql-tag';
import apolloClient from '../apollo';

/**
 * State
 */
const getDefaultState = () => {
  return {
    ordersExportBuildState: null,
    itemInventoriesExportBuildState: null,
  };
};

const state = getDefaultState();

/**
 * Request of the order list export: with a project number the block project-orders (the server
 * forces the project), without it the global export of the view orders.
 */
const ordersExportRequest = ({ userId, pagination, sorting, filters, projectNumber }) => {
  if (projectNumber) {
    return {
      mutation: gql`
        mutation projectOrdersExport(
          $projectNumber: Int!
          $pagination: PaginationInput!
          $sorting: SortingInput!
          $filters: OrderFilterInput!
        ) {
          projectOrdersExport(
            projectNumber: $projectNumber
            pagination: $pagination
            sorting: $sorting
            filters: $filters
          )
        }
      `,
      variables: { projectNumber, pagination, sorting, filters },
      resultField: 'projectOrdersExport',
    };
  }
  return {
    mutation: gql`
      mutation ordersExport(
        $userId: ID!
        $pagination: PaginationInput!
        $sorting: SortingInput!
        $filters: OrderFilterInput!
      ) {
        ordersExport(userId: $userId, pagination: $pagination, sorting: $sorting, filters: $filters)
      }
    `,
    variables: { userId, pagination, sorting, filters },
    resultField: 'ordersExport',
  };
};

/**
 * Actions
 */
const actions = {
  /**
   * Reset state in module
   * @param commit
   */
  reset({ commit }) {
    commit('SET_DEFAULT_STATE');
  },

  /**
   * Queue orders export
   * @param {*} param0
   * @param {*} payload
   */
  async ordersExport(
    { commit, dispatch },
    { userId, pagination, sorting, filters, projectNumber }
  ) {
    const { mutation, variables, resultField } = ordersExportRequest({
      userId,
      pagination,
      sorting,
      filters,
      projectNumber,
    });
    try {
      const response = await apolloClient.mutate({ mutation, variables });

      commit('SET_ORDERS_EXPORT_BUILD_STATE', response.data[resultField]);

      dispatch('message', {
        message: 'Export gestartet!',
        type: 'success',
        lifetime: 2,
      });

      return response.data[resultField];
    } catch (err) {
      dispatch('message', {
        message: 'Fehler beim Starten des Exports!',
        type: 'danger',
        lifetime: 1,
      });
      throw new Error(err);
    }
  },

  /**
   * Queue item inventories export
   * @param {*} param0
   * @param {*} payload
   */
  async itemInventoriesExport({ commit, dispatch }, { userId, pagination, sorting, filters }) {
    console.log('itemInventoriesExport()', userId, pagination, sorting, filters);
    try {
      const response = await apolloClient.mutate({
        mutation: gql`
          mutation itemInventoriesExport(
            $userId: ID!
            $pagination: PaginationInput!
            $sorting: SortingInput!
            $filters: ItemInventoryFilterInput!
          ) {
            itemInventoriesExport(
              userId: $userId
              pagination: $pagination
              sorting: $sorting
              filters: $filters
            )
          }
        `,
        variables: {
          userId,
          pagination,
          sorting,
          filters,
        },
      });

      commit('SET_ITEM_INVENTORIES_EXPORT_BUILD_STATE', response.data.itemInventoriesExport);

      dispatch('message', {
        message: 'Export gestartet!',
        type: 'success',
        lifetime: 2,
      });

      return response.data.itemInventoriesExport;
    } catch (err) {
      dispatch('message', {
        message: 'Fehler beim Starten des Exports!',
        type: 'danger',
        lifetime: 1,
      });
      throw new Error(err);
    }
  },
};

/**
 * Mutations
 */
const mutations = {
  SET_DEFAULT_STATE: (state) => {
    Object.assign(state, getDefaultState());
  },
  SET_ORDERS_EXPORT_BUILD_STATE: (state, buildState) => {
    state.ordersExportBuildState = buildState;
  },
  SET_ITEM_INVENTORIES_EXPORT_BUILD_STATE: (state, buildState) => {
    state.itemInventoriesExportBuildState = buildState;
  },
};

/**
 * Getters
 */
const getters = {
  getOrdersExportBuildState: (state) => state.ordersExportBuildState,
  getItemInventoriesExportBuildState: (state) => state.itemInventoriesExportBuildState,
};

export default {
  state,
  getters,
  actions,
  mutations,
};
